<div class="modal-content m-auto">
    <div class="modal-header">
      <lib-button
        id="confirmation-popup-close-button"
        class="d-flex justify-content-end"
        [size]="'custom'"
        [width]="32"
        [height]="32"
        [faIcon]="'far fa-times'"
        [color]="'primary-link'"
        (buttonClicked)="close($event)">
      </lib-button>
    </div>
    <div class="modal-body text-center">
      <span class="modal-title text-primary font-size-normal-small pr-1 pl-1 text-break">
          {{text}}
      </span>
    </div>
    <div class="modal-footer position-relative">
        <lib-button
          id="confirmation-popup-cancel-button"
          class="mr-2"
          [color]="'secondary'"
          [label]="'BUTTONS.CANCEL' |translate"
          (buttonClicked)="close($event)">
        </lib-button>
        <lib-button
          id="confirmation-popup-save-button"
          [label]="'BUTTONS.CONFIRM' |translate"
          (buttonClicked)="confirm($event)" >
        </lib-button> 
    </div>
</div>
